// extracted by mini-css-extract-plugin
export default {"menucontent":"menucontent_menucontent__jAzQw","inlinetag":"menucontent_inlinetag__wzoj0"};